import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox as HeroCheckbox } from '@heroui/react';
export const Checkbox = (props) => {
    return _jsx(HeroCheckbox, { ...props });
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map